import { Col, Form, FormInstance, Row } from 'antd';
import { useIntl } from 'react-intl';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { InputDecimal } from '@/components/_common';
import { TaskApplicationFormValues } from '@/core/domain/operational/TaskAppllication/TaskApplication.types';
import BrandsModelsSelect from '@/components/_common/BrandsModelsSelect';

interface Props {
  form: FormInstance<TaskApplicationFormValues>;
  type?: 'update' | 'create';
}

function ApplicationForm({ form, type }: Props) {
  const intl = useIntl();

  return (
    <Form form={form} layout="vertical">
      <Row gutter={[16, 6]}>
        <Col span={24}>
          <BrandsModelsSelect form={form} type={type} />
        </Col>

        <Col span={12}>
          <FloatingFormItem
            name="applicationExecutionTime"
            label={intl.formatMessage({
              id: 'task.application.form.time',
            })}
          >
            <InputDecimal min={0} fractions={2} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default ApplicationForm;
